var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _vm.isLoading
        ? _c("b-loading", { attrs: { "is-full-page": true } })
        : _c(
            "div",
            { staticClass: "container" },
            [
              _c("div", { staticClass: "level" }, [
                _c("div", { staticClass: "level-left" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("customer.scan_stock.total_quantity")) +
                        ": " +
                        _vm._s(_vm.totalStockQuantity)
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "level-right" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { type: "is-primary", disabled: !_vm.hasStock },
                        on: { click: _vm.exportScanStock },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.export")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "1000px" },
                attrs: {
                  modules: _vm.modules,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "group-display-type": _vm.groupDisplayType,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.stock,
                  "column-defs": _vm.columnDefs,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }